export default __webpack_public_path__ + "static/media/img_introduce_banner_2.f698a1d8.png";